<template>
  <div>
    <el-dialog
      top="5vh"
      title="开具发票"
      :visible.sync="dialogVisible"
      width="60%"
      :before-close="handleClose"
    >
      <div style="height: 75vh">
        <el-button @click="select" size="small" style="margin-bottom: 5px">
          查询
        </el-button>
        <el-button @click="makeInvoice"> 开电子发票 </el-button>
        <el-descriptions
          :column="1"
          border
          size="mini"
          :labelStyle="{ width: '80px', color: 'black' }"
          :contentStyle="{ width: '80%' }"
        >
          <el-descriptions-item label="房产">
            <el-select
              size="mini"
              v-model="form.houseName"
              filterable
              remote
              clearable
              reserve-keyword
              placeholder="可搜索房产"
              :remote-method="remoteMethod"
              :loading="loading"
              style="width: 100%"
            >
              <el-option
                v-for="item in houseList"
                :key="item.id"
                :label="item.house"
                :value="item.house"
              ></el-option>
            </el-select>
          </el-descriptions-item>
          <el-descriptions-item label="收取时间">
            <el-date-picker
              size="mini"
              v-model="startDate"
              type="date"
              format="yyyy-MM-dd"
              value-format="timestamp"
              placeholder="开始时间"
            />
            <span class="cdj_text_data">至</span>
            <el-date-picker
              size="mini"
              v-model="endDate"
              type="date"
              format="yyyy-MM-dd"
              value-format="timestamp"
              placeholder="结束时间"
            />
          </el-descriptions-item>
          <el-descriptions-item label="类型">
            <el-radio v-model="form.type" label="0">全部</el-radio>
            <el-radio v-model="form.type" label="1">未开票</el-radio>
            <el-radio v-model="form.type" label="2">已开票</el-radio>
          </el-descriptions-item>
        </el-descriptions>
        <div>
          <span>
            选中金额：
            <span style="color: red">{{ money_val }}</span>
            元
          </span>
          <span style="margin-left: 15px">
            总金费：
            <span style="color: red">{{ money }}</span>
            元
          </span>
          <span style="margin-left: 15px; color: red" v-if="loading_dade == 2">
            加载中...
          </span>
        </div>
        <el-table
          height="53vh"
          :data="listData"
          border
          style="margin-top: 8px"
          v-loading="loading"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="55" />
          <el-table-column label="客户" prop="name" />
          <el-table-column label="房产" prop="house" />
          <el-table-column label="收费项目" prop="chargeitem_name" />
          <el-table-column label="金额" prop="money" />
          <el-table-column label="收取日期" prop="charge_date" />
          <el-table-column label="发票号码" prop="invoice_no" />
          <el-table-column label="操作人" prop="user_name" />
        </el-table>
        <el-pagination
          style="float: right; margin-top: 5px"
          background
          :small="true"
          layout="sizes,prev, pager, next"
          :page-sizes="[10, 20, 30, 50, 100, 200]"
          :page-size.sync="form.pageSize"
          :total="totalCount"
          :current-page.sync="form.page"
          @size-change="search"
          @current-change="search"
        />
      </div>
    </el-dialog>

    <invoice-form ref="invoiceFormRef" :order_type="'advance'" @close="select"></invoice-form>
  </div>
</template>

<script>
import InvoiceForm from './order/electronicInvoiceForm.vue';

export default {
  name: "advanceInvoice",
  components : {
    InvoiceForm
  },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    houseName: {
      type: String,
      default: "",
    },
    pindexId: {
      type: [String, Number],
      default: "",
    },
  },
  watch: {
    houseName(n) {
      this.form.houseName = n;
    },
  },
  data() {
    return {
      form: {
        houseName: "",
        pindexId: "",
        page: 1,
        pageSize: 10,
        startDate: "",
        endDate: "",
        type: "0",
      },
      endDate: "",
      startDate: "",
      houseList: [],
      listData: [],
      totalCount: 0,
      loading: false,
      selection: [],
      loading_dade: 1,
      money: 0,
      money_val: 0,
      order: [],

    };
  },
  mounted() {
    const today = new Date();
    const formattedDate = today.toLocaleDateString("zh-CN");
    this.startDate = new Date(formattedDate).getTime();
    this.endDate = new Date(formattedDate).getTime();
  },
  methods: {
    handleClose() {
      this.$emit("close", false);
    },
    select() {
      this.form.page = 1;
      this.search();
      this.getMoney();
    },
    search() {
      this.loading = true;
      this.form.pindexId = this.pindexId;
      this.form.startDate = this.startDate / 1000;
      this.form.endDate = this.endDate / 1000;
      this.$myhttp
        .post("admin/Advances/getAdvanceInvoice", this.form, {
          "Content-Type": "application/json",
        })
        .then((backdata) => {
          if (backdata.data.code == 200) {
            this.listData = backdata.data.data;
            this.totalCount = backdata.data.totalCount;
            this.form.page = backdata.data.page;
            this.loading = false;
          } else {
            this.$message.error(backdata.data.msg);
            this.loading = false;
          }
        })
        .catch((err) => {
          this.$message.error(err);
          this.loading = false;
        });
    },
    getMoney() {
      this.loading_dade = 2;
      this.form.pindexId = this.pindexId;
      this.form.startDate = this.startDate / 1000;
      this.form.endDate = this.endDate / 1000;
      this.$myhttp
        .post("admin/Advances/getAdvanceInvoiceMoney", this.form, {
          "Content-Type": "application/json",
        })
        .then((backdata) => {
          if (backdata.data.code == 200) {
            this.money = backdata.data.money;
            this.loading_dade = 1;
          } else {
            this.$message.error(backdata.data.msg);
            this.loading_dade = 1;
          }
        })
        .catch((err) => {
          this.$message.error(err.msg);
          this.loading_dade = 1;
        });
    },
    remoteMethod(query) {
      if (query !== "") {
        // console.log(query);
        this.loading = true;
        this.$myhttp
          .get(
            "admin/common/house_text?text=" +
              query +
              "&project_id=" +
              this.pindexId,
            {
              "Content-Type": "application/json",
            }
          )
          .then((backdata) => {
            // 异步执行成功后
            this.houseList = backdata.data.data;
            this.loading = false;
          });
      } else {
        this.houseList = [];
      }
    },
    handleSelectionChange(val) {
      this.order = val;
      let money = 0;
      this.order.map((req) => {
        money = Number(money) + Number(req.money);
      });
      this.money_val = money.toFixed(2);
    },
    makeInvoice() {
      let id = this.order.map((req) => {
        return req.id;
      });
      if (id.length == 0) {
        this.$Message.error("请选择开票订单");
      } else {
        this.$refs.invoiceFormRef.openInvoiceForm(this.pindexId,this.order);
      }
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Admin/Order/advanceInvoice.vue